import { Grid, TextField } from "@mui/material";
import { formatCPF } from "../../helpers/format";

type FilterCobrancaProps = {
  //   searchCobranca: () => void;
  cpfAluno: string;
  setCpfAluno: React.Dispatch<React.SetStateAction<string>>;
};

export const FilterCobranca = ({
  //   searchCobranca,
  cpfAluno,
  setCpfAluno,
}: FilterCobrancaProps) => {
  return (
    <Grid
      container
      spacing={1} // Reduz o espaçamento
    >
      <Grid size={{ xs: 12, lg: 3 }}>
        <TextField
          label="CPF do Aluno"
          size="small"
          fullWidth
          value={cpfAluno}
          onChange={(e) => formatCPF(e.target.value, setCpfAluno)}
        />
      </Grid>
    </Grid>
  );
};
